import { useEffect, useState } from "react"
import { Button, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { formatDinero } from "./../../../utils/formatDinero"
import { useSelector, useDispatch } from "react-redux"
import { obtenerPenalizacionCancelacion, cancelarPaqueteAction, obtnerViajeRefenciaAction } from "../../../ducks/cambiosDuck"
import BackDrop from "./../../../global/BackDrop"
export const VCancelacionesStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    }
}))

const VCancelaciones = () => {
    const classes = VCancelacionesStyle()
    const dispatch = useDispatch()
    const { penalizacionCancel, viaje } = useSelector(store => store.cambios)
    const [load, setLoad] = useState(false)
    console.log("🚀 ~ file: index.jsx:28 ~ VCancelaciones ~ penalizacionCancel:", penalizacionCancel)
    useEffect(() => {
        setLoad(true)
        dispatch(obtenerPenalizacionCancelacion({ IdPaquete: viaje?.Paquete?.Id_Paquete })).then(Response =>{
            setLoad(false)
        })
    }, [dispatch, viaje?.Paquete?.Id_Paquete])
    const onCancelar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de aplicar la cancelación?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(cancelarPaqueteAction({ IdPaquete: viaje?.Paquete?.Id_Paquete })).then(Response => {
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    dispatch(obtnerViajeRefenciaAction())
                    ToastMessage.fire(
                        'Se aplico la cancelacion!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Typography variant="h6">
                    Total a cobrar por la cancelación del paquete: {`${formatDinero(penalizacionCancel.MontoPenalizacion)} ${viaje.Moneda?.Clave}`}
                </Typography>
                <Typography variant="h6">
                    Total no cobrado:  {`${formatDinero((penalizacionCancel.MontoPenalizacion - viaje?.Suma < 0) ? 0 :penalizacionCancel.MontoPenalizacion - viaje?.Suma )} ${viaje.Moneda?.Clave}`}
                </Typography>
                <Typography variant="h6">
                    Total a devolver al cliente: {`${formatDinero((penalizacionCancel.MontoPenalizacion - viaje?.Suma < 0) ? (penalizacionCancel.MontoPenalizacion - viaje?.Suma ) * -1 : 0 )} ${viaje.Moneda?.Clave}`}
                </Typography>
            </div>
            <div className={classes.contentButton}>
                <Button onClick={onCancelar} variant="contained" color="primary">
                    Aplicar cancelación
                </Button>
            </div>
            <BackDrop open={load} />
        </div>
    )
}
export default VCancelaciones